module.exports = class ProductCategoriesFormCtrl
  $onInit: ->
    @title = if @isNew then 'New Product Category' else 'Edit Product Category'

  submit: ->
    @onSubmit(productCategory: @productCategory)
